<template>
  <v-container
    id="groupSummaryFields"
  >
    <v-row>
      <v-col cols="12">
        <base-display-value
          v-model="group.groupName"
          label="Group"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <base-display-value
          v-model="group.legalBusinessName"
          label="Legal Business Name"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <base-display-value
          v-model="group.businessAddress"
          label="Business Address"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        sm="6"
      >
        <base-display-value
          v-model="group.businessCity"
          label="Business City"
        />
      </v-col>
      <v-col
        cols="6"
        sm="3"
      >
        <base-display-value
          v-model="group.businessState"
          label="Business State"
        />
      </v-col>
      <v-col
        cols="6"
        sm="3"
      >
        <base-display-value
          v-model="group.businessZip"
          label="Business Zip"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <base-display-value
          v-model="group.taxId"
          label="Tax ID"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <base-display-value
          v-model="group.hrAdminName"
          label="HR Admin Name"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <base-display-value
          v-model="group.hrAdminEmail"
          label="HR Admin Email"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <base-display-value
          v-model="group.hrAdminPhone"
          label="HR Admin Phone"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <base-display-value
          v-model="group.hrAdminName2"
          label="HR Admin Name (2)"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <base-display-value
          v-model="group.hrAdminEmail2"
          label="HR Admin Email (2)"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <base-display-value
          v-model="group.hrAdminPhone2"
          label="HR Admin Phone (2)"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'GroupSummaryFields',

    props: {
      group: {
        type: Object,
        default: null,
      },
    },
  }
</script>
